import { render, staticRenderFns } from "./Detail9.vue?vue&type=template&id=50df5abd&scoped=true&"
import script from "./Detail9.vue?vue&type=script&lang=js&"
export * from "./Detail9.vue?vue&type=script&lang=js&"
import style0 from "./Detail9.vue?vue&type=style&index=0&id=50df5abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df5abd",
  null
  
)

export default component.exports